import React, { Component } from 'react';

import { browserHistory } from 'react-router';

import './components/tenant_profile/TenantProfile.css';

import { connect } from 'react-redux';

import * as surveyActions from 'actions/surveyActions';

import { CSSTransitionGroup } from 'react-transition-group';
import { SyncLoader } from 'halogenium';

export default connect(
  store => {
    return {
      showSuccessfulVerificationMessage: store.survey.showSuccessfulVerificationMessage,
      showLoader: store.survey.showLoader,
    };
  },
  dispatch => {
    return {
      getTenantPermissionToEnter: uuid => {
        dispatch(surveyActions.getTenantPermissionToEnter(uuid));
      },
      displayLoader: shouldDisplay => {
        dispatch(surveyActions.displayLoader(shouldDisplay));
      },
    };
  }
)(
  class TenantMaintenanceVerification extends Component {
    componentDidMount() {
      const query_params = browserHistory.getCurrentLocation().query;
      if (query_params && query_params.uuid) {
        this.props.displayLoader(true);
        this.props.getTenantPermissionToEnter(query_params.uuid);
      } else {
        browserHistory.push('/dashboard');
      }
    }

    render() {
      return (
        <div className="container application-container">
          {this.props.showLoader && (
            <div style={{ marginTop: '25px' }}>
              <SyncLoader color="#ff5656" size="12px" />
            </div>
          )}
          <CSSTransitionGroup transitionName="fade_in" transitionAppear={true}>
            {this.props.showSuccessfulVerificationMessage && (
              <div>
                <h3
                  style={{
                    textAlign: 'center',
                    fontSize: '30px',
                    marginBottom: '10px',
                  }}
                >
                  {' '}
                  Unit Access{' '}
                </h3>
                <div className="row" style={{ textAlign: 'center' }}>
                  <div>
                    <p style={{ fontSize: '14px', textAlign: 'justify', marginTop: 0 }}>
                      Thank you for providing us with access to your unit. We will continue to keep
                      you updated throughout the maintenance process.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </CSSTransitionGroup>
        </div>
      );
    }
  }
);
